module.exports = __webpack_public_path__ + "static/media/Roberts-Hunter-Regular.2fc2fe3d.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Roberts-Hunter-Regular.woff
// module id = 2240
// module chunks = 53